import { isNotNil, isNumber } from 'uikit';

export const getTagLabelDefault = (id: string, name: string, filterValue: any) => {
    const localFilterValue = isNumber(filterValue) ? { name: String(filterValue) } : filterValue;

    if (!isNotNil(localFilterValue)) {
        return name;
    }
    let restName = '';

    if (Array.isArray(localFilterValue)) {
        restName = localFilterValue
            .map((_a) => {
                // eslint-disable-next-line @typescript-eslint/no-shadow
                const { name } = _a;

                return name;
            })
            .join(', ');
    }
    if (localFilterValue.min && localFilterValue.max) {
        restName = `\u043E\u0442 ${localFilterValue.min} \u0434\u043E ${localFilterValue.max}`;
    } else if (localFilterValue.min) {
        restName = `\u043E\u0442 ${localFilterValue.min}`;
    } else if (localFilterValue.max) {
        restName = `\u0434\u043E ${localFilterValue.max}`;
    }
    if (localFilterValue.name) {
        restName = `${localFilterValue.name}`;
    }

    return name + restName;
};
